import { render, staticRenderFns } from "./Listings.vue?vue&type=template&id=55583fe6&scoped=true"
import script from "./Listings.vue?vue&type=script&lang=js"
export * from "./Listings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55583fe6",
  null
  
)

export default component.exports